import Vue from 'vue';
import Icon from './Icon';
import Pagination from './Pagination';
import FormItem from './form/item';
import Loading from './Loading';
import NoAuth from './NoAuth';
import Empty from './Empty';
import Space from './Space';
import NetworkError from './NetworkError';
import Upload from './Upload';
import Tinymce from './Tinymce';
import ParamsItem from '_c/Params/Item';
import DeviceAvatar from '_c/DeviceAvatar';
import UploadOSS from '_c/UploadOSS';
import ImageSlider from '_c/ImageSlider';

Vue.component('Icon', Icon);
Vue.component('Pagination', Pagination);
Vue.component('FormItem', FormItem);
Vue.component('Loading', Loading);
Vue.component('NoAuth', NoAuth);
Vue.component('Empty', Empty);
Vue.component('Space', Space);
Vue.component('NetworkError', NetworkError);
Vue.component('Upload', Upload);
Vue.component('Tinymce', Tinymce);
Vue.component('ParamsItem', ParamsItem);
Vue.component('DeviceAvatar', DeviceAvatar);
Vue.component('UploadOSS', UploadOSS);
Vue.component('ImageSlider', ImageSlider);
